<template>
  <section class="report-section">
    <b-row>
      <b-col>
        <h3>{{ index }}.{{ index_index }} Indicatori di Performance {{ vectorName }}</h3>
      </b-col>
    </b-row>

    <ipg-charts v-if="hasIPG" :ipg="vectorIPG" :months="ipg.months" :index="index" :index_index="index_index" :site_guid="siteGuid" :month="month" :vector="vector" />
  </section>
</template>

<script>

import IpgCharts from './H1_Indexes_ipg'

export default {
  name: "indexes",
  props: ['siteGuid', 'month', 'index', 'vector', 'ipg', 'ip', 'index_index'],
  components: { IpgCharts },

  computed: {
    vectorName() {
      let vector = this.$store.state.vectors.list.find(v => v.code == this.vector)
      if(vector)
        return vector.name

      return ""
    },
    indexes() {

    },
    hasIPG() {
      if(this.ipg && this.ipg.items)
        return _.filter(this.ipg.items, { vector: this.vector }) != undefined

      return false
    },
    vectorIPG() {
      return _.filter(this.ipg.items, { vector: this.vector })[0]
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Report/H_Indexes.vue